import { ViewChild, Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ToastService } from 'ng-uikit-pro-standard';
import { SharedService } from '../../../shared/shared.service';
import { finalize } from 'rxjs/operators';
import { AppConstants } from '../../../config.service';
import { UploadService } from '../../../header/header-component/upload/upload.service';
import { UtilityService } from '../../../shared/utility.service';
import { GlobalConstants } from "../../../global-constants";
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from 'src/app/auth.service';

@Component({
    selector: 'add-document-modal',
    templateUrl: 'add-document-modal.component.html',
    styles: [`
    .modal-body .dropbox {
      font-size: 14px;
      border: 3px dashed #ededed;
      height: 90px;
      text-align: center;
      cursor: pointer;
      color: #999;
      padding-top: 20px;
      margin: 10px;
    }
    .modal-body .removeType {
      position: absolute;
      top: 15px;
      right: 18px;
      z-index: 10;
      color: silver;
    }
    .modal-body .drop-list {
      max-height: 150px;
      overflow: auto;
    }
    `]
})

export class AddDocumentModalComponent implements OnInit {

    @ViewChild('dropDocumentsModal', { static: true })
    dropDocumentsModal: any;

    @Output('confirmUpdate') confirmUpdate = new EventEmitter<boolean>();
    
    selectedDevice: any = {};
    constructor(
        private service: SharedService,
        private appConstants: AppConstants,
        public toastr: ToastService,
        private UploadService: UploadService,
        private utilityService: UtilityService,
        private translate: TranslateService,
        public authService: AuthService
    ) {

    }

    userInfo: any = {}
    ngOnInit() {
        const user = this.appConstants.userDetails;
        this.userInfo = user
    }
  
    doc: any = [];
    async startUpload() {
        this.dropDocumentsModal.hide();
        this.docs = [];
        const docs = [];
        const getDocs = Object.assign([], this.selectedDocumentList);
        for (let k = 0; k < getDocs.length; k++) {
            const tagLoop = getDocs[k];
            for (let j = 0; j < tagLoop.files.length; j++) {
                const fileLoop = tagLoop.files[j];
                const obj: any = {};
                obj.file = fileLoop;
                obj.fileName = fileLoop.name;
                obj.referenceId = this.utilityService.UUID().toLowerCase();
                obj.fileSizeInBytes = fileLoop.size;
                obj.tags=[{ id: tagLoop.id }];
                docs.push(Object.assign({}, obj));
                this.docs.push(Object.assign({}, obj));
            }
        }
        const modify = Object.assign([], docs);
        if (modify.length)
            modify.forEach(element => {
                delete element.file;
            });

        const obj = { userName:this.userInfo.email,aboutPath:'/trutesta-accreditation-services/accreditations/' + this.scheduleInfo.id + '/documents',  installationId: this.selectedDevice.installationId, documents: modify };
        const url =  this.appConstants.endPoints.sprigApiEndPoint + 'documents/' + GlobalConstants.applicationId + '/documents/multiple';
        this.service.post(url, {}, obj, true).subscribe(response => {
            // this.toastr.success(this.translate.instant("Activity Created"));              
            let uploadInfo = [];
            const docResult = response.body;
            for (let i = 0; i < docResult.length; i++) {
                for (let l = 0; l < this.docs.length; l++) {
                    if (docResult[i].referenceId == this.docs[l].referenceId) {
                        const url = this.selectedDevice.basePathUrl + '/documents/upload/' + docResult[i].id + '?uk=1&installationId=' + this.selectedDevice.installationId + '&fileSize=' + this.docs[l].file.size + '&userName=' + this.userInfo.username + '&fileName=' + encodeURIComponent(this.docs[l].file.name);
                        uploadInfo.push({
                            id:docResult[i].id,
                            url: url,
                            param: null,
                            method: 'PUT',
                            fieldName: 'fileUpload',
                            body: this.docs[l].file
                        })                           
                    }
                }
            }
            this.UploadService.receiveFiles.next({upload:uploadInfo});
        }, err => {
            // this.toastr.error(err.errorMessage)
        });
    }


    allDocumentTypes: Array<any> = [];
    selectedDocumentTags: Array<any> = [];
    selectedDocumentList: Array<any> = [];
    scheduleInfo: any = {};
    dropDocumentsLoader:boolean=false;
    open(obj) {
        this.checkSprigAvailable(obj);
    }

    sprigWarningData: any = {};
    checkSprigAvailable(obj) {
        const getLocalSprig = localStorage.getItem('selectedDevice')
        const getSelectedSprig = getLocalSprig ? JSON.parse(getLocalSprig) : null;
        this.selectedDevice = getSelectedSprig

        if (getSelectedSprig && getSelectedSprig.basePathUrl && getSelectedSprig.installationId) {
            this.selectedDocumentTags = [];
            this.selectedDocumentList = [];
            this.scheduleInfo = obj;
            this.dropDocumentsLoader = true;
            this.dropDocumentsModal.show();
            this.getDocumentTags().then((data: any) => {
                data.options = data.options.map(function (obj) { return { "id": obj.uuid, "name": obj.name } });
                this.allDocumentTypes = data.options;
                if (data.selectedOptions.length) {
                    this.selectedDocumentTags = data.selectedOptions.map((obj) => { return obj.uuid });
                    this.selectedDocumentList = data.selectedOptions.map((obj) => { return { id: obj.uuid, name: obj.name, files: [] } });
                }
                this.dropDocumentsLoader = false;

            })
        }
        else {
            this.authService.checksprigAvailable.next({ sprigNotAvailable: true, modalTitle: this.translate.instant('administration_unableToUploadDocuments_label') })
        }
    }

    uploadFile(event, type, ev) {
        for (let index = 0; index < event.length; index++) {
            const element = event[index];
            element['id'] = Date.now() + Math.random()

            if (type && type.files == undefined)
                type['files'] = [];
            type.files.push(element)

        }
        if (ev && ev.target)
            ev.target.value = null
    }

    removeItem(obj) {
        let index = -1;
        for (let i = 0; i < this.selectedDocumentList.length; i++) {
            if (this.selectedDocumentList[i].id == obj.id) {
                index = i;
            }
        }
        this.selectedDocumentList.splice(index, 1);
    }

    removeTag(e) {
        if (e.value) {
            const list = this.selectedDocumentList;
            for (let j = 0; j < list.length; j++) {
                if (list[j].id == e.value.id) {
                    this.removeItem(list[j])
                }
            }
        }
    }
    addTag(e) {
        this.selectedDocumentList.push({ id: e.id, name: e.name, files: [] })
    }

    removeSelectedType(obj, index) {
        const selectedTags = Object.assign([], this.selectedDocumentTags);
        const tagIndex = selectedTags.indexOf(obj.id);
        selectedTags.splice(tagIndex, 1);
        this.selectedDocumentTags = [];
        this.selectedDocumentTags = Object.assign([], selectedTags);
        if (obj && obj.files) {
            obj.files = [];
        }
        this.selectedDocumentList.splice(index, 1);
    };

    isLoading:boolean=false
    async getDocumentTags() {
        this.isLoading=true
        return new Promise((resolve, reject) => {
            const url = this.appConstants.endPoints.sprigApiEndPoint + "preferences/" + GlobalConstants.scheduleApplicationId + "/preferred_tags";
            this.service.get(url, { userName: this.userInfo.username })
            .pipe(finalize(() => {
                this.isLoading = false;
              })).subscribe(res => {
                resolve(res);
            }, err => {
                reject(err);
            });
        })
    }
    docs: any = [];
    fileFilterDocType(parent) {
        if (typeof parent != 'undefined') {
            if (typeof this.docs != 'undefined') {
                let children = [];
                for (let i = 0; i < this.docs.length; i++) {
                    if (this.docs[i].documentType.uuid == parent.id) {
                        children.push(this.docs[i]);
                    }
                }
                return children;
            }
        }
    };

    removeFile(id: string): void {
        let index = -1;
        for (let i = 0; i < this.selectedDocumentList.length; i++) {
            let firstLoop = this.selectedDocumentList[i];
            for (let j = 0; j < firstLoop.files.length; j++) {
                let secondLoop = firstLoop.files[j];
                if (secondLoop.id == id) {
                    index = j;
                    firstLoop.files.splice(index, 1);
                }
            }
        }
    }

    checkSelectedDocsValidation() {
        if (this.dropDocumentsModal && this.dropDocumentsModal._isShown) {
            let isDisabled = false;
            if (this.selectedDocumentList && this.selectedDocumentList.length)
                isDisabled = this.selectedDocumentList.some(e => { return e.files.length < 1 })
            else
                isDisabled = true;
            return isDisabled;
        }
    }

}
